import api from '@/api';
import { batch } from 'react-redux';

import { prepareResearchDates } from './normalize';

const initialState = {
    /*
        Словарь соответствий версии РИГИС и пластов для выбранной скважины.
        С помощью этого словаря происходит поиск пласта, который относится к активной версии РИГИС.
        Пласт содержит информацию о своем позиционировании.
    */
    stratumsByWell: {},
    /*
        Список ГДИ исследований для выбранной скважины.
    */
    gdiByWell: {},
    /*
        Свойство отвечает за видимость исследований для выбранной скважины.
        TODO: название плохое.
    */
    research: {},
};

export const gdiWellModel = {
    name: 'gdiWell',
    state: initialState,
    reducers: {
        setStratumsByWell(state, payload) {
            const { wellId, data = {} } = payload;
            const { stratumsByWell } = state;

            const updateStratumsByWell = { ...stratumsByWell, [wellId]: data };
            return { ...state, stratumsByWell: updateStratumsByWell };
        },
        setGdiByWell(state, payload) {
            const { wellId, data = [] } = payload;
            const { gdiByWell } = state;

            const updateGdiByWell = { ...gdiByWell, [wellId]: data };
            return { ...state, gdiByWell: updateGdiByWell };
        },
        setGdiResearchByWell(state, payload) {
            const { wellId, data = [] } = payload;
            const { research } = state;

            const updateResearch = { ...research, [wellId]: prepareResearchDates(data) };
            return { ...state, research: updateResearch };
        },
        /*
            Изменить видимость выбранного исследования у скважины.
        */
        changeVisible(state, payload) {
            const { wellId, date } = payload;
            const { research } = state;

            const wellResearches = research[wellId];
            const updateWellResearches = { ...wellResearches, [date]: !wellResearches[date] };
            const updateResearches = { ...research, [wellId]: updateWellResearches };

            return { ...state, research: updateResearches };
        },
        /*
            Изменить видимость всех доступных исследований у скважины.
        */
        changeVisibleAll(state, payload) {
            const { wellId, checked } = payload;
            const { research, gdiByWell } = state;

            const gdiList = gdiByWell[wellId] || [];
            const updateWellResearches = gdiList.reduce((acc, item, index) => {
                const key = `${item.date}_${index}`;
                const hasData = Array.isArray(item.data) && item.data.length > 0;
                acc[key] = hasData ? checked : false;
                return acc;
            }, {});

            const updateResearches = { ...research, [wellId]: updateWellResearches };

            return { ...state, research: updateResearches };
        },
        /*
            Сброс информации о видимости исследований по скважине (сброс состояния).
            Цель: не переполнять модель информацией.
        */
        resetResearchVisibilityById(state, wellId) {
            const { research } = state;

            // eslint-disable-next-line no-unused-vars
            const { [wellId]: removedId, ...rest } = research;

            return { ...state, research: rest };
        },
    },
    effects: dispatch => ({
        async init(wellId, rootState) {
            const gdiByWell = rootState.gdiWell.gdiByWell;

            if (!(wellId in gdiByWell)) {
                await this.getGdiByWell(wellId);
            } else {
                this.setGdiResearchByWell({ wellId, data: gdiByWell[wellId] });
            }
        },
        async getGdiByWell(wellId) {
            dispatch.tablets.incrementingCurrentRequests();

            try {
                const body = { wellId: [wellId] };
                const result = await api.carottage.fetchGdi(body);

                const { stratumsByWell, GDIByWell } = result;

                batch(() => {
                    this.setStratumsByWell({ wellId, data: stratumsByWell[wellId] });
                    this.setGdiByWell({ wellId, data: GDIByWell[wellId] });
                    this.setGdiResearchByWell({ wellId, data: GDIByWell[wellId] });
                });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log('Error occurred while loading apples', error);
            }

            dispatch.tablets.decrementingCurrentRequests();
        },
    }),
};
